import { __decorate } from "tslib";
import { Vue, Component, Mixins } from "vue-property-decorator";
import ButtonApp from "@/components/ButtonApp.vue";
import IconSvg from "@/components/IconSvg.vue";
import ItemAdv from "@/components/ItemAdv.vue";
import { uiMapper } from "@/services/store/modules/ui/store";
import { dataMapper } from "@/services/store/modules/data/store";
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(["breakpoint"]),
    },
    methods: {
        ...uiMapper.mapMutations(["openFormCall"]),
    },
});
const DataMappers = Vue.extend({
    computed: {
        ...dataMapper.mapGetters(["formMail"]),
    },
    methods: {
        ...dataMapper.mapMutations([
            "setFormCallTitle",
            "setFormCallScreen",
            "activateFormField",
            "clearForm",
        ]),
    },
});
let ScreenAdv = class ScreenAdv extends Mixins(UiMappers, DataMappers) {
    get formCallMail() {
        return this.formMail("callback");
    }
    async onOpenFormBooking(formText) {
        this.clearForm("callback");
        await this.$nextTick();
        this.setFormCallTitle("Забронировать место");
        this.setFormCallScreen(`Модальное окно 'Забронировать место' / Экран 'Стоимость' / ${formText}`);
        this.activateFormField(this.formCallMail);
        this.openFormCall();
    }
};
ScreenAdv = __decorate([
    Component({
        components: {
            ButtonApp,
            ItemAdv,
            IconSvg,
        },
    })
], ScreenAdv);
export default ScreenAdv;
